export enum CallStatus {
    ANSWERED = 'ANSWERED',
    NO_ANSWER = 'NO_ANSWER',
    BUSY = 'BUSY',
    DITCHED = 'DITCHED',
    ON_PROGRESS = 'ON_PROGRESS',
}
